var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoofSlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_3690)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0991211,
    width: 16,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09912 10.5H4.09912V12.5H6.59912V10.5H9.59912V12.5H12.0991V10.5H15.0991V12.5H16.0991V13.5H14.0991V11.5H13.0991V13.5H8.59912V11.5H7.59912V13.5H3.09912V11.5H2.09912V13.5H0.0991211V12.5H1.09912V10.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09912 0H3.09912L2.09912 10.5H1.09912L2.09912 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59912 0H8.59912L7.59912 10.5H6.59912L7.59912 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0991 0H14.0991L13.0991 10.5H12.0991L13.0991 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09912 0H5.09912L4.09912 10.5H3.09912L4.09912 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59912 0H10.5991L9.59912 10.5H8.59912L9.59912 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0991 0H16.0991L15.0991 10.5H14.0991L15.0991 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09912 13.5H0.0991211V16H16.0991V13.5H14.0991V11.5H13.0991V13.5H8.59912V11.5H7.59912V13.5H3.09912V11.5H2.09912V13.5Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_3690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofSlab);
export default __webpack_public_path__ + "static/media/roof-slab.9195fbc0e66961cfbaf29718388e4f47.svg";
export { ForwardRef as ReactComponent };